import { useState, useEffect, useCallback } from 'react';

/**
 * Hook personalizado para manejar el scroll
 * @param {number} threshold - Umbral de scroll para activar el estado
 * @returns {Object} - Estado del scroll y funciones
 */
export const useScroll = (threshold = 90) => {
    const [isScrolled, setIsScrolled] = useState(false);

    const handleScroll = useCallback(() => {
        setIsScrolled(window.scrollY >= threshold);
    }, [threshold]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    const scrollToTop = useCallback(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const scrollToElement = useCallback((elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    return {
        isScrolled,
        scrollToTop,
        scrollToElement,
    };
}; 